import React from 'react';
import PropTypes from 'prop-types';

import styles from './ProductImage.css';
import errorImage from './loading-error.svg';

const IPropTypes = {
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'xs']).isRequired,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const createSrcSet = (src, size) => (
  ['1x', '2x', '3x'].map(density => `${src}-${size}-${density}.jpg ${density}`).join(',')
);

/*
  Product images have special sizes depending on which
  card they're shown.

  There are four sizes: lg, md, sm and xs.
  All of these have three versions: 1x, 2x and 3x (for screen density).
  Note that this component requires specifying the size.
*/


class ProductImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageError: false,
    };
    this._handleImageError = this._handleImageError.bind(this);
  }
  _handleImageError() {
    this.setState({ imageError: true });
  }
  render() {
    return (
      <div className={[this.props.className, styles.imagesContainer].join(' ')}>
        {/* The following svg is a white placeholder of the image when the image is loading */}
        <svg className={styles.svgWhite} viewBox="0 0 16 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect id="Rectangle" x="0" y="0" width="16" height="9" />
          </g>
        </svg>
        {this.state.imageError &&
          <img className={styles.imageError} src={errorImage} alt="" />
        }
        { !this.state.imageError &&
          <img
            alt=""
            onError={this._handleImageError}
            // src must be redefined to avoid issues
            src={`${this.props.src}-${this.props.size}-1x.jpg`}
            srcSet={createSrcSet(this.props.src, this.props.size)}
            className={styles.productImage}
          />
        }
      </div>
    );
  }
}
ProductImage.propTypes = IPropTypes;
ProductImage.defaultProps = defaultProps;

export { ProductImage };



// WEBPACK FOOTER //
// ./src/common/product-image/ProductImage.jsx